import { render, staticRenderFns } from "./assetDynamic.vue?vue&type=template&id=46f866e4&scoped=true"
import script from "./assetDynamic.vue?vue&type=script&lang=js"
export * from "./assetDynamic.vue?vue&type=script&lang=js"
import style0 from "./assetDynamic.vue?vue&type=style&index=0&id=46f866e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f866e4",
  null
  
)

export default component.exports